export default __webpack_public_path__ + "static/media/Barbarous Loincloth.ee6159b5.jpg";